export default __webpack_public_path__ + "static/media/pexels_cottonbro_lwres_retouched.0fd620ff.jpg";